import {
  ref,
  watch,
} from 'vue';

export function useLocalStorage(key: string, defaultValue: any, decode = false) {
  const model = ref(defaultValue);

  try {
    model.value = localStorage.getItem(key) ?? defaultValue;
    if (model.value && decode) {
      model.value = JSON.parse(model.value);
    }
  } catch {
    model.value = defaultValue;
  }

  watch(model, (newValue: string) => {
    localStorage.setItem(key, newValue);
  });

  return model;
}
